export const en = {
    no: 'No',
    yes: 'Yes'
};
